import * as yup from 'yup';
import UIStrings from '@/Utils/UIStrings';

export const emailTemplateSchema = yup.object({
    title: yup.string().required(UIStrings.Required),
    regards: yup.string().required(UIStrings.Required),
});

export type TemplateEditorForm = yup.InferType<typeof emailTemplateSchema>;
